import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LanguageData = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'German' },
];

export interface LanguageSelectProps {
  value?: string;
  onChange?: (value: { value: string; label: string }) => void;
}

const LanguageSelect = ({ value, onChange }: LanguageSelectProps) => {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language === 'de' ? 'German' : 'English';
  const selectedValue = value || i18n.language || 'en';

  const handleChange = (event: SelectChangeEvent<string>) => {
    const selectedLang = LanguageData.find((lang) => lang.value === event.target.value);
    if (!selectedLang) return;

    onChange?.(selectedLang);
    void i18n.changeLanguage(selectedLang.value).then(() => {
      localStorage.setItem('i18nextLng', selectedLang.value);
      void i18n.reloadResources();
    });
  };

  return (
    <Select
      value={selectedValue}
      onChange={handleChange}
      displayEmpty
      renderValue={() => {
        const selected = LanguageData.find((lang) => lang.value === selectedValue);
        return selected?.label || currentLanguage;
      }}
      sx={{ minWidth: 140 }}
    >
      {LanguageData.map((lang) => (
        <MenuItem key={lang.value} value={lang.value}>
          {lang.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageSelect;
